import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["className", "ratio", "children", "src", "style"];
import React from 'react';
import pt from 'prop-types';
import { Element, BreakpointContext, breakpointPropSwitch } from '../';
import { appendHtmlClass, extendProps, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var ASPECT_RATIO = getConfig('ASPECT_RATIO');
var ASPECT_RATIO_DEFAULT = getConfig('ASPECT_RATIO_DEFAULT');
var ASPECT_RATIO_PREFIX = getConfig('ASPECT_RATIO_PREFIX');
var AspectRatio = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AspectRatio, _React$Component);
  function AspectRatio() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'aspect-ratio';
    return _this;
  }
  var _proto = AspectRatio.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.getRatioClass = function getRatioClass(ratio) {
    var key = this.getResponsiveValue(ratio);
    return "" + ASPECT_RATIO_PREFIX + key;
  };
  _proto.getClass = function getClass(className, ratio) {
    className = appendHtmlClass(className, this.DEFAULT_CLASS);
    return appendHtmlClass(className, this.getRatioClass(ratio));
  };
  _proto.getStyle = function getStyle(style, src) {
    var url = this.getResponsiveValue(src);
    if (typeof style !== 'object') style = {};
    return url ? Object.assign({}, style, {
      backgroundImage: "url(" + url + ")"
    }) : style;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      ratio = _this$props.ratio,
      children = _this$props.children,
      src = _this$props.src,
      style = _this$props.style,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/React.createElement(Element, Object.assign({
      className: this.getClass(className, ratio),
      style: this.getStyle(style, src)
    }, rest), children && /*#__PURE__*/React.createElement("div", {
      className: "aspect-ratio-box"
    }, children));
  };
  return AspectRatio;
}(React.Component);
AspectRatio.contextType = BreakpointContext;
Object.assign(AspectRatio, extendProps(Element, ['align', 'className', 'id', 'children', 'style', 'isAnimated'], {
  ratio: responsivePropType.bind(this, pt.oneOf(ASPECT_RATIO.map(function (i) {
    return i.key;
  }))),
  src: responsivePropType.bind(this, pt.string)
}, {
  ratio: ASPECT_RATIO_DEFAULT
}));
export default AspectRatio;